import { state as checkoutState, dispose } from '@store/checkout';
import { Product } from '../../../types';
import { withDefaultData } from '../index';

// A caller `metadata` must merge with, not replace, the attribution keys abandoned-checkout
// recovery reads.
describe('withDefaultData metadata merge', () => {
  beforeEach(() => {
    dispose();
    (window as any).scData = { page_id: 42 };
    checkoutState.product = { id: 'prod_1' } as Product;
  });

  it('keeps both the caller keys and the composed keys', () => {
    const { metadata } = withDefaultData({ metadata: { gift_note: 'wrap it' } });

    expect(metadata).toEqual({
      gift_note: 'wrap it',
      page_id: 42,
      buy_page_product_id: 'prod_1',
      page_url: window.location.href,
    });
  });

  it('does not let the caller clobber the composed keys', () => {
    const { metadata } = withDefaultData({
      metadata: { page_id: 'evil', page_url: 'https://evil.test/', buy_page_product_id: 'prod_evil' },
    });

    expect(metadata.page_id).toBe(42);
    expect(metadata.page_url).toBe(window.location.href);
    expect(metadata.buy_page_product_id).toBe('prod_1');
  });

  it('leaves a no-metadata call unchanged and keeps caller top-level overrides', () => {
    const data = withDefaultData({ email: 'a@b.com', live_mode: false } as any);

    expect((data as any).email).toBe('a@b.com');
    expect(data.live_mode).toBe(false);
    expect(data.metadata).toEqual({
      page_id: 42,
      buy_page_product_id: 'prod_1',
      page_url: window.location.href,
    });
  });
});
